<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-default">
            </div>
            <div class="container shape-container pt-md">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-7">
                        <h2 class="text-white display-1">Política de <span>Privacidade</span></h2>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <h3 class="mb-4">Vamos ser bem claros em relação ao seus dados</h3>
                <p>Acho que ninguém gosta de ler aquela porção de informações jurídicas em relação à proteção dos teus dados na internet. Vamos jogar limpo. Vou te explicar quais são os dados e qual a necessidade de recolhermos essas informações.</p>
                <p>Pra você utilizar as funcionalidades de trocas de títulos em nosso website, é necessário registrar-se com suas informações pessoais (nome completo, e-mail). Você também poderá registrar-se utilizando uma conta social (Google ou Facebook). Para a viabilização da troca via mídia física, precisaremos também do teu endereço. O restante das informações preenchidas no site são facultativas.</p>
                <p>Gerenciamos as doações para cobrir os custos de preparo e envio dos títulos em troca através do gateway de pagamentos Mercado Pago. Caso você utilize algum formato de doação diferente do Depósito Bancário, seus dados pessoais e informações como número do cartão de crédito serão gerenciados pela empresa Mercado Pago com 100% de segurança em todas as operações. Optamos pela utilização de um gateway de pagamentos para garantir total segurança para nossos usuários em suas trocas realizadas no site.</p>
                <p>Todas as informações que relatamos coletar dos nossos usuários são armazenadas em servidores de última geração, com segurança garantida, além de toda a informação do site trafegar em ambiente seguro (HTTPS).</p>
                <p>Caso você, usuário do nosso site, tenha interesse em remover seu cadastro de nosso banco de dados, assim como todo teu histórico de trocas (opt-out), você poderá entrar em contato conosco <router-link to="/contato">utilizando nosso formulário de contato.</router-link></p>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "policyprivacy",
  components: {}
};
</script>
